import React from 'react';
import ceramicdepot from '../img/ceramicdepot.png';
import compass from '../img/compass.png';
import kentoo from '../img/kentoo.png';
import perpetual from '../img/perpetual.png';
import tafra from '../img/tafra.png';
import solaireKenya from '../img/solaire-kenya.png';

const clients = [
  { src: ceramicdepot, name: 'Ceramic Depot', url: 'https://ceramicdepot.co.ke/' },
  { src: compass, name: 'Compass Energy', url: 'https://www.compassenergy.solar/' },
  { src: kentoo, name: 'Kentoo', url: 'https://kentoo.co.ke/' },
  { src: perpetual, name: 'Perpetual Energy', url: 'https://www.linkedin.com/company/perpetual-energy-ltd' },
  { src: tafra, name: 'Tafra Energy', url: 'https://www.tafraenergy.com/' },
  { src: solaireKenya, name: 'Solaire Kenya', url: 'https://solaire-kenya.com/' },
];

const LogoRow = ({ items, duration = 25, reverse = false, className = '' }) => (
  <div className={`relative flex overflow-hidden py-1 md:py-2 ${className}`}>
    <div
      className="flex items-center gap-16 md:gap-28"
      style={{
        animation: `marquee ${duration}s linear infinite`,
        animationDirection: reverse ? 'reverse' : 'normal',
        display: 'flex',
        width: 'max-content',
      }}
    >
      {items.map((client, index) => (
        <a
          key={index}
          href={client.url}
          target="_blank"
          rel="noopener noreferrer"
          className="block flex-shrink-0 transition-all duration-300 hover:scale-110"
        >
          <img
            src={client.src}
            alt={client.name}
            className="h-20 md:h-28 w-auto object-contain drop-shadow-sm"
          />
        </a>
      ))}
    </div>
  </div>
);

const ClientsSection = () => {
  const triple = [...clients, ...clients, ...clients];

  return (
    <section className="py-12 md:py-24 bg-white overflow-hidden">
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.33%); }
        }
      `}</style>
      <div className="max-w-[100vw] mx-auto text-center">
        <div>
          <h2 className="text-3xl md:text-5xl lg:text-5xl text-gray-900 leading-tight mb-12 px-4 font-bold">
            Brands We've Worked With
          </h2>

          <div className="hidden lg:flex justify-center">
            <LogoRow items={triple} duration={25} />
          </div>
          <div className="flex flex-col gap-2 lg:hidden">
            <LogoRow items={triple} duration={18} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientsSection;
